import { makeStyles } from '@material-ui/core';

const useNeoWrapperModulesStyles = makeStyles(() => ({
  moduleList: {
    paddingBottom: '24px',
    height: '90%',
    margin: '0 14px 0 0'
  },
  supportTooltipWrapper: {
    padding: '0px 16px'
  },
  supportTooltip: {
    height: '56px',
    marginTop: '1.5em',
    position: 'relative',
    color: 'var(--semantic-status-success, #388E3C)',
    fontSize: '14px',
    fontWeight: 500,
    background: '#EBF4EC',
    padding: '8px 50px 8px 16px',
    borderRadius: '4px',
    boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.25)',
    "&::before": {
      content: '""',
      width: '0',
      height: '0',
      borderLeft: '8px solid transparent',
      borderRight: '8px solid transparent',
      borderTop: '13px solid #EBF4EC',
      position: 'absolute',
      left: 'calc(50% - 8px)',
      bottom: '-11px',
      zIndex: '2',
    }
  },
  betaTag: {
    position: 'absolute',
    right: 0,
    top: 0,
    height: '49px'
  },
}));

export default useNeoWrapperModulesStyles;
